import { render, staticRenderFns } from "./FourMatViewMentor.vue?vue&type=template&id=13b1676d&scoped=true&"
import script from "./FourMatViewMentor.vue?vue&type=script&lang=js&"
export * from "./FourMatViewMentor.vue?vue&type=script&lang=js&"
import style0 from "./FourMatViewMentor.vue?vue&type=style&index=0&id=13b1676d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b1676d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VIcon,VSheet})
